import React, {Fragment} from "react";
import {usePromiseTracker} from "react-promise-tracker";
import {ThreeDots} from "react-loader-spinner";
import "./style.scss";

/** This component will display ThreeDots component of react-loader-spinner
 *whenever promise which is being tracked by react-promise-tracker library*/

const Loader = () => {
  const {promiseInProgress} = usePromiseTracker();

  return (
    <Fragment>
      {promiseInProgress && (
        <div id="loader" className={"loader-container"}>
          <div className={"loader-content"}>
            <ThreeDots color="#11cdef" height="100" width="100" />
          </div>
        </div>
      )}
    </Fragment>
  );
};

export default Loader;
